export const csvMappingRechargeSales = (obj) => {
  const { partnerRole, data, option, tileName, section } = obj;

  let result = data;
  ({
    distribution: () => {
      ({
        ZD: () => {
          ({
            "RDS": () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["REGION"] = obj["region"] ?? "";
                    obj["STATE"] = obj["state"] ?? "";
                    obj["RDS_ID"] = obj["rds"] ?? "";
                    obj["RDS_Name"] = obj["rdsName"] ?? "";
                    obj["STATUS"] = obj["status"] ?? "";
                    obj["MTD"] = obj["mtd"] ?? "";
                    obj["LMTD"] = obj["lmtd"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
              }[option]());
              return result;
            },
            "RETAILERS BILLED": () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Retailer"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Retailer Role"] = obj["partnerRoleName"] ?? "";
                    obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["REGION"] = obj["region"] ?? "";
                    obj["STATE"] = obj["state"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS NAME"] = obj["rdsName"] ?? "";
                    obj["RETAILER"] = obj["retailer"] ?? "";
                    obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                    obj["STATUS"] = obj["status"] ?? "";
                    obj["MTD"] = obj["mtd"] ?? "";
                    obj["LMTD"] = obj["lmtd"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                },
              }[option]());
              return result;
            },
            "RECHARGING RETAILERS": () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["billedCount"];
                delete obj["jprTypeCode"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtd"];
                delete obj["mtd"];
                delete obj["partnerRoleName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
            },
          }[tileName]());
          return result;
        },
        RDS: () => {
          ({
            'RETAILERS BILLED': () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Retailer"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Retailer Role"] = obj["partnerRoleName"] ?? "";
                    obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["REGION"] = obj["region"] ?? "";
                    obj["STATE"] = obj["state"] ?? "";
                    obj["ZD_ID"] = obj["zd"] ?? "";
                    obj["ZD_NAME"] = obj["zdName"] ?? "";
                    obj["RDS_ID"] = obj["rds"] ?? "";
                    obj["RDS_Name"] = obj["rdsName"] ?? "";
                    obj["Retailer"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["STATUS"] = obj["status"] ?? "";
                    obj["MTD"] = obj["mtd"] ?? "";
                    obj["LMTD"] = obj["lmtd"] ?? "";
                    obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
              }[option]());
              return result;
            },
            "RECHARGING RETAILERS": () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["billedCount"];
                delete obj["jprTypeCode"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtd"];
                delete obj["mtd"];
                delete obj["partnerRoleName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        ITZ: () => {
          ({
            "ITD": () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ITD"] = obj["retailer"] ?? "";
                    obj["ITD Name"] = obj["retailerName"] ?? "";
                    obj["IT ZD"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["REGION"] = obj["region"] ?? "";
                    obj["STATE"] = obj["state"] ?? "";
                    obj["IT ZD"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["STATUS"] = obj["status"] ?? "";
                    obj["MTD"] = obj["mtd"] ?? "";
                    obj["LMTD"] = obj["lmtd"] ?? "";
                    obj["ITD"] = obj["retailer"] ?? "";
                    obj["ITD Name"] = obj["retailerName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
              }[option]());
              return result;
            },
            "RETAILERS BILLED": () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Name"] = obj["retailer"] ?? "";
                    obj["Retailer Role"] = obj["retailerName"] ?? "";
                    obj["Retailer"] = obj["zd"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["REGION"] = obj["region"] ?? "";
                    obj["STATE"] = obj["state"] ?? "";
                    obj["ITZD"] = obj["zd"] ?? "";
                    obj["ITZD NAME"] = obj["zdName"] ?? "";
                    obj["ITD"] = obj["rds"] ?? "";
                    obj["ITD NAME"] = obj["rdsName"] ?? "";
                    obj["RETAILER"] = obj["retailer"] ?? "";
                    obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                    obj["STATUS"] = obj["status"] ?? "";
                    obj["MTD"] = obj["mtd"] ?? "";
                    obj["LMTD"] = obj["lmtd"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
              }[option]());
              return result;
            },
            "RECHARGING RETAILERS": () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["ITD"] = obj["zd"] ?? "";
                obj["ITD Name"] = obj["zdName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["billedCount"];
                delete obj["jprTypeCode"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtd"];
                delete obj["mtd"];
                delete obj["partnerRoleName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        ITD: () => {
          ({
            "RETAILERS BILLED": () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Name"] = obj["retailer"] ?? "";
                    obj["Retailer Role"] = obj["retailerName"] ?? "";
                    obj["Retailer"] = obj["zd"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["REGION"] = obj["region"] ?? "";
                    obj["STATE"] = obj["state"] ?? "";
                    obj["ITZD ID"] = obj["zd"] ?? "";
                    obj["ITZD NAME"] = obj["zdName"] ?? "";
                    obj["ITD ID"] = obj["rds"] ?? "";
                    obj["ITD Name"] = obj["rdsName"] ?? "";
                    obj["RETAILER_ID"] = obj["retailer"] ?? "";
                    obj["RETAILER_NAME"] = obj["retailerName"] ?? "";
                    obj["STATUS"] = obj["status"] ?? "";
                    obj["MTD"] = obj["mtd"] ?? "";
                    obj["LMTD"] = obj["lmtd"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
              }[option]());
              return result;
            },
            "RECHARGING RETAILERS": () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["billedCount"];
                delete obj["jprTypeCode"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtd"];
                delete obj["mtd"];
                delete obj["partnerRoleName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        RZD: () => {
          ({
            "RETAILERS BILLED": () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["DRS NAME"] = obj["retailer"] ?? "";
                    obj["DRS ID"] = obj["retailerName"] ?? "";
                    obj["RZD"] = obj["rds"] ?? "";
                    obj["RZD NAME"] = obj["rdsName"] ?? "";
                    obj["TYPE CODE"] = obj["jprTypeCode"] ?? "";
                    obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                    obj["BILLED"] = obj["billedCount"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["REGION"] = obj["region"] ?? "";
                    obj["STATE"] = obj["state"] ?? "";
                    obj["RZD"] = obj["rds"] ?? "";
                    obj["RZD NAME"] = obj["rdsName"] ?? "";
                    obj["DRS ID"] = obj["retailer"] ?? "";
                    obj["DRS NAME"] = obj["retailerName"] ?? "";
                    obj["STATUS"] = obj["status"] ?? "";
                    obj["MTD"] = obj["mtd"] ?? "";
                    obj["LMTD"] = obj["lmtd"] ?? "";
                    obj["JPR TYPE CODE"] = obj["jprTypeCode"] ?? "";
                    obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
              }[option]());
              return result;
            },
            "RECHARGING DIRECT RURAL STORES": () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["DRS ID"] = obj["retailer"] ?? "";
                obj["DRS NAME"] = obj["retailerName"] ?? "";
                obj["RZD"] = obj["rds"] ?? "";
                obj["RZD NAME"] = obj["rdsName"] ?? "";
                obj["BILLED"] = obj["lmtd"] ?? "";
                obj["TYPE CODE"] = obj["jprTypeCode"] ?? "";
                obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["billedCount"];
                delete obj["jprTypeCode"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtd"];
                delete obj["mtd"];
                delete obj["partnerRoleName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        ARD: () => {
          ({
            "UNIQUE ACTIVATING OUTLET (UAO)": () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Retailer"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["RETAILER_ID"] = obj["retailer"] ?? "";
                    obj["RETAILER_NAME"] = obj["retailerName"] ?? "";
                    obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
              }[option]());
              return result;
            },
            "RECHARGING RETAILERS": () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Retailer"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Retailer"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                    obj["STATUS"] = obj["status"] ?? "";
                    obj["MTD"] = obj["mtd"] ?? "";
                    obj["LMTD"] = obj["lmtd"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
              }[option]());
              return result;
            },
            "RETAILERS BILLED": () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["billedCount"];
                delete obj["jprTypeCode"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtd"];
                delete obj["mtd"];
                delete obj["partnerRoleName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        MARD: () => {
          ({
            "UNIQUE ACTIVATING OUTLET (UAO)": () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Retailer"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["RETAILER_ID"] = obj["retailer"] ?? "";
                    obj["RETAILER_NAME"] = obj["retailerName"] ?? "";
                    obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                    obj["STATUS"] = obj["status"] ?? "";
                    obj["MTD"] = obj["mtd"] ?? "";
                    obj["LMTD"] = obj["lmtd"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
              }[option]());
              return result;
            },
            "RECHARGING RETAILERS": () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Retailer"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Retailer"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                    obj["STATUS"] = obj["status"] ?? "";
                    obj["MTD"] = obj["mtd"] ?? "";
                    obj["LMTD"] = obj["lmtd"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
              }[option]());
              return result;
            },
            "RETAILERS BILLED": () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["billedCount"];
                delete obj["jprTypeCode"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtd"];
                delete obj["mtd"];
                delete obj["partnerRoleName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        ZDMT: () => {
          ({
            "CHAIN": () => {
              ({
                billed: () => {
                  result = data.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["CHAIN_ID"] = obj["retailer"] ?? "";
                    obj["CHAIN_NAME"] = obj["retailerName"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
                onboard: () => {
                  result = data.map((obj) => {
                    obj["REGION"] = obj["region"] ?? "";
                    obj["STATE"] = obj["state"] ?? "";
                    obj["CHAIN_CODE"] = obj["rds"] ?? "";
                    obj["CHAIN_NAME"] = obj["rdsName"] ?? "";
                    obj["STATUS"] = obj["status"] ?? "";
                    obj["MTD"] = obj["mtd"] ?? "";
                    obj["LMTD"] = obj["lmtd"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["billedCount"];
                    delete obj["jprTypeCode"];
                    delete obj["jprTypeName"];
                    delete obj["status"];
                    delete obj["lmtd"];
                    delete obj["mtd"];
                    delete obj["partnerRoleName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    return obj;
                  });
                  return result;
                },
              }[option]());
              return result;
            },
            "STORES BILLED": () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["CHAIN ID"] = obj["rds"] ?? "";
                obj["CHAIN Name"] = obj["rdsName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["billedCount"];
                delete obj["jprTypeCode"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtd"];
                delete obj["mtd"];
                delete obj["partnerRoleName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        CHAIN: () => {
          ({
            billed: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["CHAIN ID"] = obj["rds"] ?? "";
                obj["CHAIN NAME"] = obj["rdsName"] ?? "";
                obj["STORE ID"] = obj["retailer"] ?? "";
                obj["STORE NAME"] = obj["retailerName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["billedCount"];
                delete obj["jprTypeCode"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtd"];
                delete obj["mtd"];
                delete obj["partnerRoleName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
              return result;
            },
            onboard: () => {
              result = data.map((obj) => {
                obj["REGION"] = obj["region"] ?? "";
                obj["STATE"] = obj["state"] ?? "";
                obj["Chain Id"] = obj["zd"] ?? "";
                obj["Chain Name"] = obj["zdName"] ?? "";
                obj["Store Id"] = obj["rds"] ?? "";
                obj["Store Name"] = obj["rdsName"] ?? "";
                obj["STATUS"] = obj["status"] ?? "";
                obj["MTD Status"] = obj["mtd"] ?? "";
                obj["LMTD Status"] = obj["lmtd"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["billedCount"];
                delete obj["jprTypeCode"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtd"];
                delete obj["mtd"];
                delete obj["partnerRoleName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
              return result;
            },
          }[option]());
          return result;
        },
        JP: () => {
          ({
            billed: () => {
              result =
                data &&
                data.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["Jio Point Id"] = obj["jioPointId"] ?? "";
                  obj["Jio Point Name"] = obj["jioPointName"] ?? "";
                  obj["Retailer Id"] = obj["retailerId"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["Billed"] = obj["billed"];
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["retailerId"];
                  delete obj["retailerName"];
                  delete obj["retailer_count"];
                  delete obj["jprTypeName"];
                  delete obj["billed"];
                  return obj;
                });
              return result;
            },
            onboard: () => {
              result =
                data &&
                data.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jioCenter"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Jio Point Id"] = obj["jio_point_id"] ?? "";
                  obj["Jio Point Name"] = obj["jio_point_name"] ?? "";
                  obj["Retailer Id"] = obj["retailerId"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Status"] = obj["status"] ?? "";
                  obj["MTD Billed"] = obj["mtdBilled"] ?? "";
                  obj["LMTD Billed"] = obj["lmtdBilled"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["jioCenter"];
                  delete obj["jcName"];
                  delete obj["jio_point_id"];
                  delete obj["jio_point_name"];
                  delete obj["retailerId"];
                  delete obj["retailerName"];
                  delete obj["status"];
                  delete obj["mtdBilled"];
                  delete obj["lmtdBilled"];
                  delete obj["jprTypeName"];
                  return obj;
                });
              return result;
            },
          }[option]());
          return result;
        },
      }[partnerRole]());
      return result;
    },
    sales: () => {
      ({
        ZD: () => {
          ({
            primary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["RDS_ID"] = obj["rdsId"] ?? "";
                obj["RDS_NAME"] = obj["rdsName"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            secondary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["RDS_ID"] = obj["rdsId"] ?? "";
                obj["RDS_NAME"] = obj["rdsName"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            tertiary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["RDS_CODE"] = obj["rdsId"] ?? "";
                obj["RDS_NAME"] = obj["rdsName"] ?? "";
                obj["FOS Code"] = obj["fosCode"] ?? "";
                obj["Retailer Code"] = obj["retId"] ?? "";
                obj["Retailer Name"] = obj["retName"] ?? "";
                obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                obj["Tertiary Txn Type"] = obj["tertiaryTxType"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            sell: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["RDS_CODE"] = obj["rdsId"] ?? "";
                obj["RDS_NAME"] = obj["rdsName"] ?? "";
                obj["RETAILER_CODE"] = obj["retId"] ?? "";
                obj["RETAILER_NAME"] = obj["retName"] ?? "";
                obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                obj["PLAN_CODE"] = obj["planCode"] ?? "";
                obj["PLAN_NAME"] = obj["planName"] ?? "";
                obj["RECHARGE_COUNT"] = obj["rechargeCount"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        RDS: () => {
          ({
            secondary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["RDS_ID"] = obj["rdsId"] ?? "";
                obj["RDS_NAME"] = obj["rdsName"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            tertiary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC ID"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["FOS_CODE"] = obj["fosCode"] ?? "";
                obj["RETAILER_CODE"] = obj["retId"] ?? "";
                obj["RETAILER_NAME"] = obj["retName"] ?? "";
                obj["JPR_TYPE_NAME"] = obj["jprTypeName"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                obj["Tertiary Txn Type"] = obj["tertiaryTxType"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            sell: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["RETAILER_CODE"] = obj["retId"] ?? "";
                obj["RETAILER_NAME"] = obj["retName"] ?? "";
                obj["JPR_TYPE_NAME"] = obj["jprTypeName"] ?? "";
                obj["PLAN_CODE"] = obj["planCode"] ?? "";
                obj["PLAN_NAME"] = obj["planName"] ?? "";
                obj["RECHARGE_COUNT"] = obj["rechargeCount"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        ITZ: () => {
          ({
            secondary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["ITD(rds)"] = obj["rdsId"] ?? "";
                obj["ITD Name"] = obj["rdsName"] ?? "";
                obj["IT ZD"] = obj["zd"] ?? "";
                obj["IT ZD Name"] = obj["zdName"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            tertiary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["ITD_CODE"] = obj["rdsId"] ?? "";
                obj["ITD_NAME"] = obj["rdsName"] ?? "";
                obj["FOS_Code"] = obj["fosCode"] ?? "";
                obj["RETAILER_CODE"] = obj["retId"] ?? "";
                obj["RETAILER_NAME"] = obj["retName"] ?? "";
                obj["Recharge Amount"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                obj["Tertiary Txn Type"] = obj["tertiaryTxType"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            sell: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["ITD"] = obj["rdsId"] ?? "";
                obj["ITD Name"] = obj["rdsName"] ?? "";
                obj["IT ZD"] = obj["zd"] ?? "";
                obj["IT ZD Name"] = obj["zdName"] ?? "";
                obj["RETAILER_CODE"] = obj["retId"] ?? "";
                obj["RETAILER_NAME"] = obj["retName"] ?? "";
                obj["PLAN_CODE"] = obj["planCode"] ?? "";
                obj["PLAN_NAME"] = obj["planName"] ?? "";
                obj["RECHARGE_COUNT"] = obj["rechargeCount"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        ITD: () => {
          ({
            secondary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["ITD"] = obj["rdsId"] ?? "";
                obj["ITD Name"] = obj["rdsName"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            tertiary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["FOS_CODE"] = obj["fosCode"] ?? "";
                obj["RETAILER_CODE"] = obj["retId"] ?? "";
                obj["RETAILER_NAME"] = obj["retName"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                obj["Tertiary Txn Type"] = obj["tertiaryTxType"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            sell: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["RETAILER_CODE"] = obj["retId"] ?? "";
                obj["RETAILER_NAME"] = obj["retName"] ?? "";
                obj["PLAN_CODE"] = obj["planCode"] ?? "";
                obj["PLAN_NAME"] = obj["planName"] ?? "";
                obj["RECHARGE_COUNT"] = obj["rechargeCount"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        RZD: () => {
          ({
            tertiary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["FOS_CODE"] = obj["fosCode"] ?? "";
                obj["RETAILER_CODE"] = obj["retId"] ?? "";
                obj["RETAILER_NAME"] = obj["retName"] ?? "";
                obj["JPR_TYPE"] = obj["jprTypeCode"] ?? "";
                obj["Recharge Amount"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                obj["Tertiary Txn Type"] = obj["tertiaryTxType"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            sell: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["RZD"] = obj["parentId"] ?? "";
                obj["RZD_NAME"] = obj["parentName"] ?? "";
                obj["DRS_ID"] = obj["retId"] ?? "";
                obj["DRS_NAME"] = obj["retName"] ?? "";
                obj["JPR_TYPE_NAME"] = obj["jprTypeName"] ?? "";
                obj["PLAN_CODE"] = obj["planCode"] ?? "";
                obj["PLAN_NAME"] = obj["planName"] ?? "";
                obj["RECHARGE_COUNT"] = obj["rechargeCount"] ?? "";
                obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        END: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["JC Code"] = obj["jcCode"] ?? "";
            obj["JC Name"] = obj["jcName"] ?? "";
            obj["ED_CODE"] = obj["retId"] ?? "";
            obj["ED_NAME"] = obj["retName"] ?? "";
            obj["PLAN_NAME"] = obj["planName"] ?? "";
            obj["RECHARGE_COUNT"] = obj["rechargeCount"] ?? "";
            obj["ACTUAL_VALUE"] = obj["actualValue"] ?? "";
            obj["PLAN_VALUE"] = obj["planValue"] ?? "";
            obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jcCode"];
            delete obj["jcName"];
            delete obj["rdsId"];
            delete obj["rdsName"];
            delete obj["zd"];
            delete obj["zdName"];
            delete obj["parentId"];
            delete obj["parentName"];
            delete obj["fosCode"];
            delete obj["retId"];
            delete obj["retName"];
            delete obj["jprTypeName"];
            delete obj["jprTypeCode"];
            delete obj["planCode"];
            delete obj["planName"];
            delete obj["rechargeCount"];
            delete obj["actualValue"];
            delete obj["planValue"];
            delete obj["lmtdVal"];
            delete obj["mtdVal"];
            delete obj["date"];
            delete obj["tertiaryTxType"];
            return obj;
          });
          return result;
        },
        ARD: () => {
          ({
            tertiary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["ARD_ID"] = obj["parentId"] ?? "";
                obj["ARD_NAME"] = obj["parentName"] ?? "";
                obj["FOS_CODE"] = obj["fosCode"] ?? "";
                obj["UAO_URO_ID"] = obj["retId"] ?? "";
                obj["UAO_URO_NAME"] = obj["retName"] ?? "";
                obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                obj["Recharge Amount"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                obj["Tertiary Txn Type"] = obj["tertiaryTxType"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            sell: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["ARD_ID"] = obj["parentId"] ?? "";
                obj["ARD_NAME"] = obj["parentName"] ?? "";
                obj["UAO_URO_ID"] = obj["retId"] ?? "";
                obj["UAO_URO_NAME"] = obj["retName"] ?? "";
                obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                obj["PLAN_CODE"] = obj["planCode"] ?? "";
                obj["PLAN_NAME"] = obj["planName"] ?? "";
                obj["Recharge Count"] = obj["rechargeCount"] ?? "";
                obj["Actual Value"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        MARD: () => {
          ({
            tertiary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["MARD_ID"] = obj["parentId"] ?? "";
                obj["MARD_NAME"] = obj["parentName"] ?? "";
                obj["FOS_CODE"] = obj["fosCode"] ?? "";
                obj["UAO_URO_ID"] = obj["retId"] ?? "";
                obj["UAO_URO_NAME"] = obj["retName"] ?? "";
                obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                obj["Recharge Amount"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                obj["Tertiary Txn Type"] = obj["tertiaryTxType"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            sell: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["ARD_ID"] = obj["parentId"] ?? "";
                obj["ARD_NAME"] = obj["parentName"] ?? "";
                obj["UAO_URO_ID"] = obj["retId"] ?? "";
                obj["UAO_URO_NAME"] = obj["retName"] ?? "";
                obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
                obj["PLAN_CODE"] = obj["planCode"] ?? "";
                obj["PLAN_NAME"] = obj["planName"] ?? "";
                obj["Recharge Count"] = obj["rechargeCount"] ?? "";
                obj["Actual Value"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        ZDMT: () => {
          ({
            secondary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["ZDMT_CODE"] = obj["parentId"] ?? "";
                obj["ZDMT_NAME"] = obj["parentName"] ?? "";
                obj["CHAIN_CODE"] = obj["retId"] ?? "";
                obj["CHAIN_NAME"] = obj["retName"] ?? "";
                obj["Actual Value"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            sell: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["CHAIN_CODE"] = obj["zd"] ?? "";
                obj["CHAIN_NAME"] = obj["zdName"] ?? "";
                obj["STORE_ID"] = obj["retId"] ?? "";
                obj["STORE_NAME"] = obj["retName"] ?? "";
                obj["PLAN_CODE"] = obj["planCode"] ?? "";
                obj["PLAN_NAME"] = obj["planName"] ?? "";
                obj["Recharge Count"] = obj["rechargeCount"] ?? "";
                obj["Actual Value"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        CHAIN: () => {
          ({
            secondary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["ZDMT"] = obj["parentId"] ?? "";
                obj["ZDMT_NAME"] = obj["parentName"] ?? "";
                obj["CHAIN_ID"] = obj["retId"] ?? "";
                obj["CHAIN_NAME"] = obj["retName"] ?? "";
                obj["Actual Value"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            sell: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["CHAIN_ID"] = obj["parentId"] ?? "";
                obj["CHAIN_NAME"] = obj["parentName"] ?? "";
                obj["STORE_ID"] = obj["retId"] ?? "";
                obj["STORE_NAME"] = obj["retName"] ?? "";
                obj["PLAN_CODE"] = obj["planCode"] ?? "";
                obj["PLAN_NAME"] = obj["planName"] ?? "";
                obj["Recharge Count"] = obj["rechargeCount"] ?? "";
                obj["Actual Value"] = obj["actualValue"] ?? "";
                obj["PLAN_VALUE"] = obj["planValue"] ?? "";
                obj["LMTD_VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["fosCode"];
                delete obj["retId"];
                delete obj["retName"];
                delete obj["jprTypeName"];
                delete obj["jprTypeCode"];
                delete obj["planCode"];
                delete obj["planName"];
                delete obj["rechargeCount"];
                delete obj["actualValue"];
                delete obj["planValue"];
                delete obj["lmtdVal"];
                delete obj["mtdVal"];
                delete obj["date"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        JP: () => {
          ({
            secondary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC ID"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["JIO point Id"] = obj["jioPointId"] ?? "";
                obj["JIO Point Name"] = obj["jioPointName"] ?? "";
                obj["RETAILER ID"] = obj["retailerId"] ?? "";
                obj["RETAILER Name"] = obj["retailerName"] ?? "";
                obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                obj["FOS CODE"] = obj["fosCode"] ?? "";
                obj["	RECHARGE COUNT"] = obj["rechargeCount"] ?? "";
                obj["	PLAN ID	"] = obj["planId"] ?? "";
                obj["PLAN NAME"] = obj["planName"] ?? "";
                obj["	PLAN VALUE"] = obj["planValue"] ?? "";
                obj["ACTUAL VALUE"] = obj["actualValue"] ?? "";
                obj["LMTD VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["actualValue"];
                delete obj["fosCode"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["jioPointId"];
                delete obj["jioPointName"];
                delete obj["jprTypeName"];
                delete obj["lmtdVal"];
                delete obj["partnerRoleName"];
                delete obj["partnerRoleType"];
                delete obj["planId"];
                delete obj["planName"];
                delete obj["planValue"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["rechargeCount"];
                delete obj["region"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["state"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            sell: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC ID"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["JIO point Id"] = obj["jioPointId"] ?? "";
                obj["JIO Point Name"] = obj["jioPointName"] ?? "";
                obj["RETAILER ID"] = obj["retailerId"] ?? "";
                obj["RETAILER Name"] = obj["retailerName"] ?? "";
                obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                obj["FOS CODE"] = obj["fosCode"] ?? "";
                obj["	RECHARGE COUNT"] = obj["rechargeCount"] ?? "";
                obj["	PLAN ID	"] = obj["planId"] ?? "";
                obj["PLAN NAME"] = obj["planName"] ?? "";
                obj["	PLAN VALUE"] = obj["planValue"] ?? "";
                obj["ACTUAL VALUE"] = obj["actualValue"] ?? "";
                obj["LMTD VALUE"] = obj["lmtdVal"] ?? "";
                delete obj["actualValue"];
                delete obj["fosCode"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["jioPointId"];
                delete obj["jioPointName"];
                delete obj["jprTypeName"];
                delete obj["lmtdVal"];
                delete obj["partnerRoleName"];
                delete obj["partnerRoleType"];
                delete obj["planId"];
                delete obj["planName"];
                delete obj["planValue"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["rechargeCount"];
                delete obj["region"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["state"];
                delete obj["tertiaryTxType"];
                return obj;
              });
              return result;
            },
            tertiary: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC ID"] = obj["jcCode"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["JIO point Id"] = obj["jioPointId"] ?? "";
                obj["JIO Point Name"] = obj["jioPointName"] ?? "";
                obj["RETAILER ID"] = obj["retailerId"] ?? "";
                obj["RETAILER Name"] = obj["retailerName"] ?? "";
                obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                obj["FOS CODE"] = obj["fosCode"] ?? "";
                obj["	RECHARGE COUNT"] = obj["rechargeCount"] ?? "";
                obj["	PLAN ID	"] = obj["planId"] ?? "";
                obj["PLAN NAME"] = obj["planName"] ?? "";
                obj["	PLAN VALUE"] = obj["planValue"] ?? "";
                obj["ACTUAL VALUE"] = obj["actualValue"] ?? "";
                obj["LMTD VALUE"] = obj["lmtdVal"] ?? "";
                obj["Tertiary Txn Type"] = obj["tertiaryTxType"] ?? "";
                delete obj["actualValue"];
                delete obj["fosCode"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["jioPointId"];
                delete obj["jioPointName"];
                delete obj["jprTypeName"];
                delete obj["lmtdVal"];
                delete obj["partnerRoleName"];
                delete obj["partnerRoleType"];
                delete obj["planId"];
                delete obj["planName"];
                delete obj["planValue"];
                delete obj["rdsId"];
                delete obj["rdsName"];
                delete obj["rechargeCount"];
                delete obj["region"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["state"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
      }[partnerRole]());
      return result;
    },
    last7Days: () => {
      ({
        ZD: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["RDS_ID"] = obj["rds"] ?? "";
            obj["RDS_NAME"] = obj["rdsName"] ?? "";
            obj["Retailer Id"] = obj["retailer"] ?? "";
            obj["Retailer Name"] = obj["retailerName"] ?? "";
            obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
            obj["Recharge Amount"] = obj["rechargeAmount"] ?? "";
            obj["REPORT_DATE"] = obj["reportDate"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jc"];
            delete obj["jcName"];
            delete obj["rds"];
            delete obj["rdsName"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["jprTypeCode"];
            delete obj["jprTypeName"];
            delete obj["rechargeAmount"];
            delete obj["reportDate"];
            return obj;
          });
          return result;
        },
        RDS: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["RDS_ID"] = obj["rds"] ?? "";
            obj["RDS_NAME"] = obj["rdsName"] ?? "";
            obj["Retailer Id"] = obj["retailer"] ?? "";
            obj["Retailer Name"] = obj["retailerName"] ?? "";
            obj["JPR_TYPE_NAME"] = obj["jprTypeName"] ?? "";
            obj["Recharge Amount"] = obj["rechargeAmount"] ?? "";
            obj["REPORT_DATE"] = obj["reportDate"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jc"];
            delete obj["jcName"];
            delete obj["rds"];
            delete obj["rdsName"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["jprTypeCode"];
            delete obj["jprTypeName"];
            delete obj["rechargeAmount"];
            delete obj["reportDate"];
            return obj;
          });
          return result;
        },
        ZDMT: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["JC_CODE"] = obj["jc"] ?? "";
            obj["JC_NAME"] = obj["jcName"] ?? "";
            obj["CHAIN_ID"] = obj["rds"] ?? "";
            obj["CHAIN_NAME"] = obj["rdsName"] ?? "";
            obj["Recharge Amount"] = obj["rechargeAmount"] ?? "";
            obj["REPORT_DATE"] = obj["reportDate"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jc"];
            delete obj["jcName"];
            delete obj["rds"];
            delete obj["rdsName"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["jprTypeCode"];
            delete obj["jprTypeName"];
            delete obj["rechargeAmount"];
            delete obj["reportDate"];
            return obj;
          });
          return result;
        },
        CHAIN: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["CHAIN_ID"] = obj["rds"] ?? "";
            obj["CHAIN_NAME"] = obj["rdsName"] ?? "";
            obj["STORE Id"] = obj["retailer"] ?? "";
            obj["STORE Name"] = obj["retailerName"] ?? "";
            obj["Recharge Amount"] = obj["rechargeAmount"] ?? "";
            obj["REPORT_DATE"] = obj["reportDate"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jc"];
            delete obj["jcName"];
            delete obj["rds"];
            delete obj["rdsName"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["jprTypeCode"];
            delete obj["jprTypeName"];
            delete obj["rechargeAmount"];
            delete obj["reportDate"];
            return obj;
          });
          return result;
        },
        ARD: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["ARD_ID"] = obj["rds"] ?? "";
            obj["ARD_NAME"] = obj["rdsName"] ?? "";
            obj["UAO_URO Id"] = obj["retailer"] ?? "";
            obj["UAO_URO Name"] = obj["retailerName"] ?? "";
            obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
            obj["Recharge Amount"] = obj["rechargeAmount"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jc"];
            delete obj["jcName"];
            delete obj["rds"];
            delete obj["rdsName"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["jprTypeCode"];
            delete obj["jprTypeName"];
            delete obj["rechargeAmount"];
            delete obj["reportDate"];
            return obj;
          });
          return result;
        },
        MARD: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["MARD_ID"] = obj["rds"] ?? "";
            obj["MARD_NAME"] = obj["rdsName"] ?? "";
            obj["UAO_URO Id"] = obj["retailer"] ?? "";
            obj["UAO_URO Name"] = obj["retailerName"] ?? "";
            obj["JPR_TYPE"] = obj["jprTypeName"] ?? "";
            obj["Recharge Amount"] = obj["rechargeAmount"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jc"];
            delete obj["jcName"];
            delete obj["rds"];
            delete obj["rdsName"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["jprTypeCode"];
            delete obj["jprTypeName"];
            delete obj["rechargeAmount"];
            delete obj["reportDate"];
            return obj;
          });
          return result;
        },
        ITZ: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["ITD"] = obj["rds"] ?? "";
            obj["ITD_NAME"] = obj["rdsName"] ?? "";
            obj["Retailer Id"] = obj["retailer"] ?? "";
            obj["Retailer Name"] = obj["retailerName"] ?? "";
            obj["Recharge Amount"] = obj["rechargeAmount"] ?? "";
            obj["REPORT_DATE"] = obj["reportDate"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jc"];
            delete obj["jcName"];
            delete obj["rds"];
            delete obj["rdsName"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["jprTypeCode"];
            delete obj["jprTypeName"];
            delete obj["rechargeAmount"];
            delete obj["reportDate"];
            return obj;
          });
          return result;
        },
        ITD: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["ITD_ID"] = obj["rds"] ?? "";
            obj["ITD_NAME"] = obj["rdsName"] ?? "";
            obj["Retailer Id"] = obj["retailer"] ?? "";
            obj["Retailer Name"] = obj["retailerName"] ?? "";
            obj["Recharge Amount"] = obj["rechargeAmount"] ?? "";
            obj["REPORT_DATE"] = obj["reportDate"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jc"];
            delete obj["jcName"];
            delete obj["rds"];
            delete obj["rdsName"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["jprTypeCode"];
            delete obj["jprTypeName"];
            delete obj["rechargeAmount"];
            delete obj["reportDate"];
            return obj;
          });
          return result;
        },
        RZD: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["RDS_ID"] = obj["rds"] ?? "";
            obj["RDS_NAME"] = obj["rdsName"] ?? "";
            obj["JPR_TYPE_NAME"] = obj["jprTypeName"] ?? "";
            obj["Recharge Amount"] = obj["rechargeAmount"] ?? "";
            obj["REPORT_DATE"] = obj["reportDate"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jc"];
            delete obj["jcName"];
            delete obj["rds"];
            delete obj["rdsName"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["jprTypeCode"];
            delete obj["jprTypeName"];
            delete obj["rechargeAmount"];
            delete obj["reportDate"];
            return obj;
          });
          return result;
        },
        JP: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["Retailer Id"] = obj["retailer"] ?? "";
            obj["Retailer Name"] = obj["retailerName"] ?? "";
            obj["JP ID"] = obj["jioPointId"] ?? "";
            obj["JP Name"] = obj["jioPointName"] ?? "";
            obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
            obj["Recharge Amount"] = obj["rechargeAmount"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["jioPointId"];
            delete obj["jioPointName"];
            delete obj["jprTypeName"];
            delete obj["rechargeAmount"];
            return obj;
          });
          return result;
        },
      }[partnerRole]());
      return result;
    },
    wallet: () => {
      ({
        ZD: () => {
          ({
            zd: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            rds: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC_CODE"] = obj["jcCode"] ?? "";
                obj["JC_NAME"] = obj["jcName"] ?? "";
                obj["RDS"] = obj["rds"] ?? "";
                obj["RDS_NAME"] = obj["rdsName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            retailer: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC_CODE"] = obj["jcCode"] ?? "";
                obj["JC_NAME"] = obj["jcName"] ?? "";
                obj["RDS"] = obj["rds"] ?? "";
                obj["RDS_NAME"] = obj["rdsName"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        RDS: () => {
          ({
            rds: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC_CODE"] = obj["jcCode"] ?? "";
                obj["JC_NAME"] = obj["jcName"] ?? "";
                obj["RDS"] = obj["rds"] ?? "";
                obj["RDS_NAME"] = obj["rdsName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            retailer: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        ARD: () => {
          ({
            zd: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["ARD CODE"] = obj["parentId"] ?? "";
                obj["ARD_NAME"] = obj["parentName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            retailer: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC_CODE"] = obj["jcCode"] ?? "";
                obj["JC_NAME"] = obj["jcName"] ?? "";
                obj["UAO_URO ID"] = obj["retailer"] ?? "";
                obj["UAO_URO Name"] = obj["retailerName"] ?? "";
                obj["ARD"] = obj["parentId"] ?? "";
                obj["ARD_NAME"] = obj["parentName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        MARD: () => {
          ({
            zd: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["MARD"] = obj["parentId"] ?? "";
                obj["MARD_NAME"] = obj["parentName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            retailer: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC_CODE"] = obj["jcCode"] ?? "";
                obj["JC_NAME"] = obj["jcName"] ?? "";
                obj["UAO_URO ID"] = obj["retailer"] ?? "";
                obj["UAO_URO Name"] = obj["retailerName"] ?? "";
                obj["MARD"] = obj["parentId"] ?? "";
                obj["MARD_NAME"] = obj["parentName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        RZD: () => {
          ({
            zd: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["RZD"] = obj["parentId"] ?? "";
                obj["RZD_NAME"] = obj["parentName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            retailer: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC_CODE"] = obj["jcCode"] ?? "";
                obj["JC_NAME"] = obj["jcName"] ?? "";
                obj["DRS ID"] = obj["retailer"] ?? "";
                obj["DRS Name"] = obj["retailerName"] ?? "";
                obj["RZD"] = obj["parentId"] ?? "";
                obj["RZD_NAME"] = obj["parentName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        ITZ: () => {
          ({
            zd: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["ITZD"] = obj["parentId"] ?? "";
                obj["IT ZD NAME"] = obj["parentName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            rds: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["ITD"] = obj["parentId"] ?? "";
                obj["ITD NAME"] = obj["parentName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            retailer: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["ITD"] = obj["parentId"] ?? "";
                obj["ITD_NAME"] = obj["parentName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        ITD: () => {
          ({
            rds: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["ITD"] = obj["rds"] ?? "";
                obj["ITD NAME"] = obj["rdsName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            retailer: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        END: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["ED"] = obj["retailer"] ?? "";
            obj["ED Name"] = obj["retailerName"] ?? "";
            obj["Wallet balance"] = obj["wballance"] ?? "";
            obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
            obj["Average per day sales"] = obj["avgSales"] ?? "";
            obj["No. of days"] = obj["noOfDays"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jcCode"];
            delete obj["jcName"];
            delete obj["zd"];
            delete obj["zdName"];
            delete obj["rds"];
            delete obj["rdsName"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["parentId"];
            delete obj["parentName"];
            delete obj["wballance"];
            delete obj["last30DaySales"];
            delete obj["avgSales"];
            delete obj["noOfDays"];
            return obj;
          });
          return result;
        },
        ZDMT: () => {
          ({
            zd: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            rds: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["CHAIN"] = obj["retailer"] ?? "";
                obj["CHAIN Name"] = obj["retailerName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            retailer: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["STORE_ID"] = obj["retailer"] ?? "";
                obj["STORE Name"] = obj["retailerName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        CHAIN: () => {
          ({
            rds: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["CHAIN_ID"] = obj["retailer"] ?? "";
                obj["CHAIN Name"] = obj["retailerName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
            retailer: () => {
              result = data.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC CODE"] = obj["jcCode"] ?? "";
                obj["JC NAME"] = obj["jcName"] ?? "";
                obj["RETAILER"] = obj["retailer"] ?? "";
                obj["RETAILER Name"] = obj["retailerName"] ?? "";
                obj["CHAIN_CODE"] = obj["parentId"] ?? "";
                obj["CHAIN_NAME"] = obj["parentName"] ?? "";
                obj["Wallet balance"] = obj["wballance"] ?? "";
                obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
                obj["Average per day sales"] = obj["avgSales"] ?? "";
                obj["No. of days"] = obj["noOfDays"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jcCode"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["wballance"];
                delete obj["last30DaySales"];
                delete obj["avgSales"];
                delete obj["noOfDays"];
                return obj;
              });
              return result;
            },
          }[tileName]());
          return result;
        },
        DT: () => {
          result = data.map((obj) => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj["DT"] = obj["zd"] ?? "";
            obj["DT Name"] = obj["zdName"] ?? "";
            obj["Wallet balance"] = obj["wballance"] ?? "";
            obj["Sales in last 30 days"] = obj["last30DaySales"] ?? "";
            obj["Average per day sales"] = obj["avgSales"] ?? "";
            obj["No. of days"] = obj["noOfDays"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jcCode"];
            delete obj["jcName"];
            delete obj["zd"];
            delete obj["zdName"];
            delete obj["rds"];
            delete obj["rdsName"];
            delete obj["retailer"];
            delete obj["retailerName"];
            delete obj["parentId"];
            delete obj["parentName"];
            delete obj["wballance"];
            delete obj["last30DaySales"];
            delete obj["avgSales"];
            delete obj["noOfDays"];
            return obj;
          });
          return result;
        },
        JP: () => {
          result = data.map((obj) => {
            obj["REGION"] = obj["region"] ?? "";
            obj["STATE"] = obj["state"] ?? "";
            obj["JC ID"] = obj["jcId"] ?? "";
            obj["JC NAME"] = obj["jcName"] ?? "";
            obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
            obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
            obj["RETAILER ID"] = obj["retailerId"] ?? "";
            obj["RETAILER NAME"] = obj["retailerName"] ?? "";
            obj["WALLET BALANCE"] = obj["walletBalance"] ?? "";
            obj["SALES IN LAST 30 DAYS"] = obj["last30DaysSales"] ?? "";
            obj["AVG. PER DAY SALES"] = obj["avgSales"] ?? "";
            obj["NO. OF DAYS"] = obj["noOfDays"] ?? "";
            delete obj["region"];
            delete obj["state"];
            delete obj["jcId"];
            delete obj["jcName"];
            delete obj["jioPointId"];
            delete obj["jioPointName"];
            delete obj["retailerId"];
            delete obj["retailerName"];
            delete obj["walletBalance"];
            delete obj["last30DaysSales"];
            delete obj["avgSales"];
            delete obj["noOfDays"];
            return obj;
          });
          return result;
        },
      }[partnerRole]());
      return result;
    },
  }[section]());
  return result;
};
